import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Globals } from '../models/globals.model';
import { Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class MLService {

  apiUri: string;
  graphUri: string;

  getModelListApi = "api/ListModel";
  getModelParametersApi = "api/GetModelParameter";

  constructor(
    private readonly httpService: HttpService, 
    private readonly globals: Globals, 
    private readonly http: HttpClient, 
    public router: Router,
    public tenantService: TenantService) {
    this.apiUri = this.globals.config.modelManagementApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  getModelList() {
    return this.http.get(this.apiUri + this.getModelListApi);
  }  

  getModelParameters(modelId) {
    return this.http.get(this.apiUri + this.getModelParametersApi + "/" + modelId);
  }

  redirectTo(url) {
    window.location.href = url;
  }

  redirectToNotifiction(eventId) {
    let url = this.router.createUrlTree(['/FSRunDetails', eventId]);
    window.open(url.toString(), '_blank');
  }

}
